// extracted by mini-css-extract-plugin
export default {"pagination-container":"Pagination_pagination-container__9e34B","active":"Pagination_active__f1x62"};